import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { sanitizeSellerHtml } from '@repo/lib';

import MultilineText from './MultilineText';
import { containPreviewStyles, scopeCss } from '../lib/containPreviewStyles';
import { previewStylesheetKey } from '../queryKeys';

function PreviewStylesheet({ href }) {
  const { data: css } = useQuery({
    queryKey: previewStylesheetKey(href),
    queryFn: async () => {
      const response = await fetch(href);
      if (!response.ok) throw new Error(`Failed to load stylesheet: ${href}`);
      return response.text();
    },
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  if (!css) return null;

  return <style dangerouslySetInnerHTML={{ __html: scopeCss(css) }} />;
}

export default function ConfirmationHtml({ html, preview, className }) {
  const safeHtml = sanitizeSellerHtml(html);

  if (!preview) {
    return <MultilineText className={className} dangerouslySetInnerHTML={{ __html: safeHtml }} />;
  }

  const contained = containPreviewStyles(safeHtml);

  return (
    <>
      {contained.stylesheets.map(href => (
        <PreviewStylesheet key={href} href={href} />
      ))}
      <MultilineText className={className} dangerouslySetInnerHTML={{ __html: contained.html }} />
    </>
  );
}
